import { ChangeDetectorRef, Component, Input, OnInit, AfterViewInit} from '@angular/core';
import { AndrenaChartColorConfig, BaseChartProvider } from './base-chart-provider';

@Component({
  selector: 'app-base-chart',
  templateUrl: './base-chart.component.html',
  styleUrls: ['./base-chart.component.scss']
})
export class BaseChartComponent {
  @Input() chartComponent: any;
  @Input() chartKey: string;
  
  public loading: boolean = false;

  // Note: Chartjs chart requires a full set up default data points in order to correct
  // size canvas during initialization. This is a workaround to avoid the issue.
  public chartConfig2: any = {
    type: 'line',
    data: [],
    options: {}
       
  };

  public chartConfig: any = '{"type":"line","data":{"labels":["January","February","March","April","May","June","July","August","September","October"],"datasets":[{"label":"Projected","data":[4,4,4,4,4,4,4,4,4,4],"borderColor":"rgba(103,189,140, 100%)","pointBackgroundColor":"rgb(255, 255, 255)","pointBorderColor":"rgba(103,189,140, 100%)","backgroundColor":{},"fill":"+1","lineTension":0.4},{"label":"Global","data":[5,5,5,5,5,5,5,5,5,5],"borderColor":"rgba(214,186,131, 100%)","pointBackgroundColor":"rgb(255, 255, 255)","pointBorderColor":"rgba(214,186,131, 100%)","backgroundColor":{},"fill":"+1","lineTension":0.4},{"label":"Domain Value","data":[0,0,0,0,0,0,0,0,0,0],"borderColor":"rgba(26,53,221, 100%)","pointBackgroundColor":"rgb(255, 255, 255)","pointBorderColor":"rgba(26,53,221, 100%)","backgroundColor":{},"fill":"origin","lineTension":0.4}]},"options":{"responsive":true,"maintainAspectRatio":false,"scales":{"x":{"display":true,"ticks":{"display":false},"title":{"display":false},"grid":{"display":false},"border":{"display":false}},"y":{"display":true,"ticks":{"count":6},"title":{"display":false},"grid":{"display":false},"border":{"display":false}}},"elements":{"point":{"backgroundColor":"rgb(255, 255, 255)","borderColor":"rgb(255, 255, 255)","radius":2,"pointStyle":"circle"}},"plugins":{"legend":{"display":true,"position":"top"},"title":{"display":false,"text":"Chart.js Line Chart"},"filler":{}}}}'

  constructor(
    private _ref: ChangeDetectorRef,
    private chartService: BaseChartProvider,
  ) {}
  
  ngOnInit() {
    var canvas = <HTMLCanvasElement>document.getElementById('base-chart');
    var ctx = canvas.getContext("2d");
    this.chartService.setupColors(ctx);
    
    this.chartService.activeChartConfig.subscribe({
      next: (config) => {
        if (config){
          this.chartConfig = config;
          this._ref.markForCheck();
        }
      }
    });
  }
}
